module.exports = __webpack_public_path__ + "img/home_service_txt.b0486abe.png";